
import { Star } from "lucide-react";
import { Card } from "@/components/ui/card";

interface CourseRatingCardProps {
  averageRating: number;
  totalReviews: number;
}

export const CourseRatingCard = ({ averageRating, totalReviews }: CourseRatingCardProps) => {
  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star 
        key={i} 
        className={`h-4 w-4 ${i < rating ? 'text-yellow-500 fill-yellow-500' : 'text-gray-300'}`} 
      />
    ));
  };

  return (
    <div className="w-full md:w-1/3 p-6 bg-card rounded-xl border shadow-sm">
      <div className="flex items-center gap-3 mb-4">
        <Star className="h-5 w-5 text-primary" />
        <h3 className="text-lg font-semibold">Course Rating</h3>
      </div>
      
      <div className="flex items-center gap-4">
        <div className="text-4xl font-bold">{averageRating?.toFixed(1)}</div>
        <div className="flex flex-col">
          <div className="flex">{renderStars(Math.round(averageRating || 0))}</div>
          <span className="text-sm text-muted-foreground mt-1">
            {totalReviews} {totalReviews === 1 ? 'review' : 'reviews'}
          </span>
        </div>
      </div>
    </div>
  );
};
